module.exports = __webpack_public_path__ + "static/media/master-service.395935bf.svg";